// extracted by mini-css-extract-plugin
export default {"newIconContainer":"NewSelectOption-module__newIconContainer--jf6Z0","animatedBackground":"NewSelectOption-module__animatedBackground--S_uzl"};